

















































import { Component, Prop, Watch } from 'vue-property-decorator'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { mapGetters } from 'vuex'
import { BButton } from 'bootstrap-vue'
import VuePdfApp from 'vue-pdf-app'
import 'vue-pdf-app/dist/icons/main.css'
import VueViewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import InputCheckBox from '../components/InputCheckBox.vue'
import Loader from '../components/Loader.vue'
import { getFileNameFromHeader, base64ToArrayBuffer } from '@/utils/helpers'
import Vue from 'vue'

Vue.use(VueViewer)

// extends Vue implements VueViewer


@Component({
    computed: {
        ...mapGetters('exa_formulaire', ['documents'])
    },
    components: {
        FontAwesomeIcon: FontAwesomeIcon,
        'b-button': BButton,
        VuePdfApp: VuePdfApp,
        // VueViewer: VueViewer,
        InputCheckBox: InputCheckBox,
        Loader: Loader
    }
})
export default class Visionneuse extends Vue {
    @Prop() getDocument!: Function | null
    @Prop() index_file_docs!: any
    index_file = 0
    index_docs = 0
    showVignette = true

    // option = { toolbar: false }    
    // option = { inline: true, button: true, navbar: true, title: false, toolbar: true, tooltip: true, movable: true, zoomable: true, rotatable: true, scalable: true, transition: true, fullscreen: true, keyboard: false, url: 'data-source' }
    // option = { inline: true, button: false, navbar: false, title: false, toolbar: true, tooltip: false, movable: true, zoomable: true, rotatable: true, scalable: true, transition: false, fullscreen: false, keyboard: false } //  
    option: any = { inline: true, button: false, navbar: false, title: false, toolbar: true, tooltip: false, movable: true, zoomable: true, rotatable: true, scalable: true, transition: false, fullscreen: false, keyboard: false, url: 'data-source' }
    config = {
        toolbar: {
            toolbarViewerRight: { presentationMode: false, openFile: false, viewBookmark: false, secondaryToolbarToggle: false }
        }
    }

    keyViewer = 1

    @Watch('index_file_docs')
    /** 
     * setIndex_file_docs 
     * Cette fonction permet de définir l'index des fichiers de documentation et d'appeler la fonction showDoc avec les indices spécifiés. 
     *  
     * @param Aucun paramètre n'est requis pour cette fonction. 
     */
    setIndex_file_docs () {
        this.showDoc(Number(this.index_file_docs.split('_')[0]), Number(this.index_file_docs.split('_')[1]))
    }


    /** 
     * download 
     * Télécharge le document spécifié. 
     * @param {any} doc - Le document à télécharger. 
     */
    download(doc: any) {
        if (doc.data) {
            const url = doc.data
            const link = document.createElement('a')
            link.href = url
            link.setAttribute(
                'Download',
                doc.titre
            )
            document.body.appendChild(link)
            link.click()
        } else {
            if (this.getDocument) {
                this.getDocument(doc.id).then((response: any) => {
                    let fileName = ''
                    const fileNameTemp = getFileNameFromHeader(response.headers) || doc.titre
                    if (fileNameTemp) {
                        fileName = fileNameTemp
                    }
                    const url = URL.createObjectURL(new Blob([base64ToArrayBuffer(response.data)]))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute(
                        'Download',
                        fileName
                    )
                    document.body.appendChild(link)
                    link.click()
                })
            }
        }
    }

    /** 
     * setDataSource 
     * Cette fonction permet de définir la source de données en fonction des options spécifiées. 
     * Si l'option url est égale à 'data-source', la source de données est définie en ligne avec certaines fonctionnalités activées. 
     * Sinon, la source de données est définie avec une URL 'data-source' et les mêmes fonctionnalités activées. 
     *  
     * @param Aucun paramètre n'est requis pour cette fonction. 
     */
    setDataSource () {
        if (this.option.url && this.option.url === 'data-source') {
            this.option = { inline: true, button: false, navbar: false, title: false, toolbar: true, tooltip: false, movable: true, zoomable: true, rotatable: true, scalable: true, transition: false, fullscreen: false, keyboard: false }
        } else {
            this.option = { inline: true, button: false, navbar: false, title: false, toolbar: true, tooltip: false, movable: true, zoomable: true, rotatable: true, scalable: true, transition: false, fullscreen: false, keyboard: false, url: 'data-source' }
        }
        this.keyViewer = Math.random()
    }

    /** 
     * showVignetteHandler 
     * Cette fonction permet de basculer l'état de l'affichage de la vignette. Si la vignette est actuellement affichée, elle sera masquée, et vice versa. 
     *  
     * @param Aucun paramètre n'est requis pour cette fonction. 
     */
    showVignetteHandler () {
        this.showVignette = !this.showVignette
    }

    /** 
     * showDoc 
     * Cette fonction permet d'afficher un document spécifique en fonction de la clé de document et de la clé de fichier spécifiées. 
     * Elle met à jour les index correspondants et vérifie si les données du fichier doivent être récupérées depuis l'API. 
     * Si les données ne sont pas disponibles, la fonction getDocument est appelée pour les récupérer.  
     *  
     * @param docKey: un paramètre de type number représentant la clé du document à afficher. 
     * @param fileKey: un paramètre de type number représentant la clé du fichier à afficher. 
     */
    showDoc (docKey: number, fileKey: number) {
        this.keyViewer = Math.random()
        this.index_docs = docKey
        this.index_file = fileKey 
        if (this.$store.getters['exa_formulaire/documents'] && 
            this.$store.getters['exa_formulaire/documents'][this.index_docs] && 
            this.$store.getters['exa_formulaire/documents'][this.index_docs].files) {
            if (this.$store.getters['exa_formulaire/documents'][this.index_docs].files[this.index_file] && 
                !this.$store.getters['exa_formulaire/documents'][this.index_docs].files[this.index_file].data && 
                this.$store.getters['exa_formulaire/documents'][this.index_docs].files[this.index_file].id && 
                this.getDocument) {
                this.downloadDoc()
            } else {
                this.keyViewer = Math.random()
            }
        }
    }
 
    async downloadDoc () {
        if (this.getDocument) {
            await this.getDocument(this.$store.getters['exa_formulaire/documents'][this.index_docs].files[this.index_file].id).then((response: any) => {
                if (!response.data.includes('data')) {
                    this.$store.getters['exa_formulaire/documents'][this.index_docs].files[this.index_file].data = 'data:' + this.detectMimeType(response.data) + ';charset=utf-8;base64,' + response.data
                } else {
                    this.$store.getters['exa_formulaire/documents'][this.index_docs].files[this.index_file].data = response.data
                }
                this.keyViewer = Math.random()
            })
        }
    }

    /** 
     * detectMimeType 
     * Cette fonction permet de détecter le type de contenu d'un fichier à partir de sa représentation en base64. 
     *  
     * @param b64 : Représentation en base64 du fichier 
     * @returns Le type MIME du fichier détecté 
    */
    detectMimeType(b64: any) {
        const signatures: any = {
            JVBERi0: 'application/pdf',
            R0lGODdh: 'image/gif',
            R0lGODlh: 'image/gif',
            iVBORw0KGgo: 'image/png',
            '/9j/': 'image/jpg'
        }
        for (const s in signatures) {
            if (b64.indexOf(s) === 0) {
                return signatures[s]
            }
        }
    }


    /** 
     * mounted 
     * Cette fonction est appelée lorsque le composant est monté. 
     * Elle initialise les index des fichiers et des documents en fonction de la valeur de l'index_file_docs. 
     * Si l'index_file_docs n'est pas une chaîne de caractères valide, les index sont définis sur 0 par défaut. 
     * Ensuite, la fonction showDoc est appelée pour afficher le document correspondant aux index spécifiés. 
     *  
     * @param Aucun paramètre n'est requis pour cette fonction. 
     */
    mounted() {
        let indexFile = 0
        let indexDoc = 0
        if (this.index_file_docs && this.index_file_docs !== '') {
            indexDoc = Number(this.index_file_docs.split('_')[0])
            indexFile = Number(this.index_file_docs.split('_')[1])
            this.showVignette = false
        }
        if (isNaN(indexFile)) {
            indexFile =  0
        }
        if (isNaN(indexDoc)) {
            indexDoc =  0
        }
        this.showDoc(indexDoc, indexFile)
    }

    /*

    beforeDestroy() {
        console.log('beforeDestroy')
        this.index_docs = 0
        this.index_file = 0
        this.showVignette = true
    }

    destroyed() {
        console.log('destroyed')
        this.index_docs = 0
        this.index_file = 0
        this.showVignette = true
    }
    */
}
